<div class="image mt-4"><img src="assets/images/empty/{{image}}" alt=""></div>
<p class=" mt-3">{{message}}</p>

<button class="primary mt-4" [routerLink]="link ? link : ''" *ngIf="buttonText != ''" >{{buttonText}}</button>